var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M2.8,17.1c-2.4,2.5-2.6,4.2,0.1,7.3c2.7,3.1,6.4,5.4,11.1,7.4c2.7,1.2,5.7,1.8,8.7,1.8h0.4 c6.8,0,13.3-3.2,19.2-9.5c2.2-2.3,2.2-4.4,0.1-6.7C37,11.4,29.7,7.6,22.5,7.7C15.3,7.9,8.5,11.2,2.8,17.1z M22.5,9.3 c6.9,0.3,13.6,3.5,18.8,9.2c1.5,1.7,1.5,2.8-0.1,4.6c-5.6,5.9-11.7,9-18.1,9h-0.4c-2.8,0-5.5-0.6-8.1-1.8c-4-1.5-7.6-3.9-10.5-6.9 c-1.8-2-1.8-3.2-0.1-5.1C9.3,12.6,15.8,9.5,22.5,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M4.1,23.4c2.9,3.1,6.5,5.4,10.5,6.9c2.5,1.1,5.3,1.7,8.1,1.8h0.4c6.4,0,12.5-3.1,18.1-9 c1.6-1.8,1.6-2.9,0.1-4.6c-5.2-5.7-11.9-9-18.8-9.2c-6.8,0.2-13.2,3.2-18.5,9C2.2,20.2,2.2,21.4,4.1,23.4z M22.5,12.1L22.5,12.1 c2.3-0.1,4.5,0.9,6.1,2.5c1.7,1.6,2.6,3.8,2.5,6.1c0,4.8-3.9,8.7-8.7,8.7c-4.8,0-8.7-3.9-8.7-8.7C13.9,16,17.8,12.2,22.5,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5,29.4c4.8,0,8.7-3.9,8.7-8.7c0-2.3-0.9-4.5-2.5-6.1c-1.6-1.7-3.8-2.6-6.1-2.6v0.1 c-4.7,0-8.6,3.9-8.7,8.6C13.8,25.5,17.7,29.4,22.5,29.4z M22.5,14.3c-1.2,2.4-0.9,4.2,0.9,5.2c1.8,1,3.4,0.4,4.8-1.8 c1.5,2.4,1.1,5.5-0.9,7.6c-2.5,2.7-6.6,2.8-9.3,0.4c-1.8-1.7-2.5-4.3-1.8-6.7C17,16.1,19.6,14.3,22.5,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M18,25.6c2.7,2.5,6.8,2.3,9.3-0.4c2-2,2.3-5.1,0.9-7.6c-1.4,2.2-3.1,2.8-4.8,1.8c-1.8-1-2.1-2.8-0.9-5.2 c-2.9-0.1-5.5,1.8-6.3,4.6C15.5,21.3,16.2,23.9,18,25.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.26cb0379caf356da818656dbec6fbd55.svg";
export { ForwardRef as ReactComponent };